export default carriers => carriers.map(carrier => ({
  value: carrier.icaoCode,
  label: `${carrier.iataCode} ${carrier.airlineName}`,
  iataCode: carrier.iataCode,
}));
